import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import * as queryString from "query-string"
import { useHistory, useLocation, useParams } from "react-router-dom"

export const useReglasConciliacionForm = () => {
  const { reglaId } = useParams<{ reglaId: string }>()
  const location = useLocation()
  const history = useHistory()

  const currentQueryParams = queryString.parse(location.search)

  const { activeCompany } = useUsuarioEmpresaActiva()

  const tipoParam = currentQueryParams.tipo
  const ibanParam = currentQueryParams.iban
  const tipoValue: number | undefined =
    typeof tipoParam === "string" ? parseInt(tipoParam, 10) : undefined
  const ibanValue: string | undefined =
    typeof ibanParam === "string" ? ibanParam : undefined
  const cuentaIdParam = currentQueryParams.cuentaId
  const cuentaIdValue: string | undefined =
    typeof cuentaIdParam === "string" ? cuentaIdParam : undefined

  const handleSuccess = () => {
    history.push({
      pathname: `/tesoreria/reglas-conciliacion/${activeCompany.nif}`,
      search: `?tipo=${tipoValue}&iban=${ibanValue}&cuentaId=${cuentaIdValue}`,
    })
  }

  return {
    handleSuccess,
    reglaId,
    tipoValue,
    ibanValue,
    cuentaIdValue,
  }
}
